import { render, staticRenderFns } from "./ColegioSelm.vue?vue&type=template&id=1926e440&scoped=true"
import script from "./ColegioSelm.vue?vue&type=script&lang=js"
export * from "./ColegioSelm.vue?vue&type=script&lang=js"
import style0 from "./ColegioSelm.vue?vue&type=style&index=0&id=1926e440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1926e440",
  null
  
)

export default component.exports